import { watch } from 'vue'
import { useIdle } from '@vueuse/core'
import { useRouter } from 'vue-router'
import { useGeneralStore } from '@/stores/general'
import { useAuthStore } from '@/stores/auth'

export const IDLE_TIMEOUT_MS = 15 * 60 * 1000 // 15 minutes

/**
 * Watches for user inactivity and expires an authenticated session.
 *
 * This has to be called once from a component that lives for the whole life of
 * the app (App.vue). It used to live inside IdleView.vue, which only rendered
 * on login/register/reset-password - so the timer never ran for a logged-in
 * user and the dashboard was never protected at all.
 *
 * IdleView.vue is now presentation only; it renders off `generalStore.isIdle`.
 */
export function useIdleSession () {
  const generalStore = useGeneralStore()
  const authStore = useAuthStore()
  const router = useRouter()

  const { idle } = useIdle(IDLE_TIMEOUT_MS)

  watch(idle, hasGoneIdle => {
    if (!hasGoneIdle) {
      generalStore.setIdle(false)
      return
    }

    /* A timeout only means something for an authenticated session. Without a
       token there is nothing to expire, which leaves the unauthenticated pages
       (login, register, reset-password) alone - previously going idle part-way
       through registering would throw the user back to login. */
    if (!authStore.token) return
    if (router.currentRoute.value.name === 'login') return

    generalStore.setIdle(true)
    authStore.idleRedirect()
  })
}
